<div appCollapsable class="item" [class.open]="item.expanded === true" *ngFor="let item of listItems; let i = index">
  <ion-button fill="clear" expand="full" class="collapse-header" (click)="expand(i)">
    <h6>{{ item.title }}</h6>
    <div [class.iconOpen]="item.expanded === true" slot="end" class="collapse-icon">
      <div class="bar"></div>
      <div class="bar"></div>
    </div>
  </ion-button>
  <div [innerHTML]="sanitizeService.sanitizeString(item.description)" class="content"></div>
</div>